<div class="wrapper">
    <input type="text" class="datetime form-control mr-1" name="dateTimePicker"
           [ngModel]="$value()"
           [ngxMatDatetimePicker]="dateTimePicker"
           [disabled]="true"
           (ngModelChange)="onChange($event.format('YYYY-MM-DD'))"
    >

    <mat-datepicker-toggle matSuffix [for]="dateTimePicker"></mat-datepicker-toggle>

    <ngx-mat-datetime-picker #dateTimePicker
                             [showSpinners]="true"
                             [showSeconds]="true"
                             [hideTime]="true"
                             [disabled]="$disabled()"
    >
        <ngx-mat-datepicker-actions>
            <button mat-button ngxMatDatepickerCancel class="btn btn-outline-danger mr-2">Cancelar</button>
            <button mat-button ngxMatDatepickerApply class="btn btn-outline-primary">Aplicar</button>
        </ngx-mat-datepicker-actions>
    </ngx-mat-datetime-picker>
</div>
